import React, { useState } from 'react';

import { useTranslation } from "react-i18next";
import { useBoolean } from '@fluentui/react-hooks';

import { Row, Col} from "react-bootstrap"
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';

import Picker from '../../../Common/Picker';
import CValidator from '../../../Common/CValidator';
import List from "../../../Templates/List"

import { useGetUsersByPartyId } from "../../../../hooks/services/sBook/useOfParty"
import { useGetSectionPartyUsersBySectionId } from "../../../../hooks/services/sBook/useOfSectionParty"
import { saveSectionPartyUsers, deleteSectionPartyUserById } from "../../../../services/sBook/section-party.service"

import { joinWithoutDupes } from '../../../../common/Helpers';
import Message from '../../../Common/Message';
import ListPagination from '../../../Templates/List/ListPagination';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../common/CommonFuctions';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';


const SidePanelUsers = (props) => {
    const { t } = useTranslation();
  
    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_BookId = props.bookId;
    const inputParam_PartyId = props.partyId;
    const inputParam_SectionId = props.sectionId;
    const inputParam_SectionPartyId = props.sectionPartyId;
    const inputParam_SetterFireGetBookUsers = props.setterFireGetBookUsers !== null && props.setterFireGetBookUsers !== undefined ? props.setterFireGetBookUsers : null;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : false;
    const inputParam_SetterUpdateUserCount = props.setterUpdateUserCount;
    const inputParam_UserHasConfigRoleAction = props.userHasConfigRoleAction !== null && props.userHasConfigRoleAction !== undefined ? props.userHasConfigRoleAction : false;

    
    const buttonAddStyles = { root: { float: "right" } };
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [message, setMessage] = useState(null);
    const [showMessage, setShowMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [isInvalidUserSelector, setIsInvalidUserSelector] = useState(false);

    
    const [selectedPickerUsers, setSelectedPickerUsers] = useState({data: null, pageNumber: 1, pageSize: 1000, filters: []});
    const [partyUsersPickerList, setPartyUsersPickerList] = useState(null);
    useGetUsersByPartyId(inputParam_PartyId, partyUsersPickerList, setPartyUsersPickerList, inputParam_IsPanelOpen, true, true)

    const [sectionPartyUserList, setSectionPartyUserList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});
    useGetSectionPartyUsersBySectionId(inputParam_SectionId, inputParam_PartyId, sectionPartyUserList.data, setSectionPartyUserList, inputParam_IsPanelOpen)

    const [itemToDelete, setItemToDelete] = useState(null);

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);

        setMessage(null);
        setShowMessage(null);
        setMessageType(null);
        setIsInvalidUserSelector(false);        
        setSelectedPickerUsers({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});
        setPartyUsersPickerList(null);    
        setSectionPartyUserList({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});
        setItemToDelete(null);
    };

    const onSaveSectionPartyUserList = () => {
        const isValidForm = sectionPartyUserList.data !== null && sectionPartyUserList.data.length > 0;

        if (isValidForm) {
            let usersToSave = [];
            sectionPartyUserList.data.forEach(partyMember => {
                usersToSave.push({
                    id: partyMember.tagClassName === undefined ? partyMember.id : 0,
                    partyMemberId: parseInt(partyMember.tagClassName === undefined ? partyMember.partyMemberId : partyMember.id),
                    sectionPartyId: inputParam_SectionPartyId
                })
            });

            saveSectionPartyUsers(inputParam_BookId, inputParam_SectionId, usersToSave).then((response) => {
                //No deberia ser necesario dejar en null para que obtenga nuevamente los usuarios. Esto dado que los usuarios del cliente no deberian vairar.
                //Pero si se quire, podemos descomentar esta linea para que cada vez que se seleccione "Seleccionar usuarios" en las card, se busquen los usuarios en el sistema.
                //setClientUserList(null);
                onDismissPanel();
                
                setSectionPartyUserList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: null
                }));
                setSelectedPickerUsers(prevState => ({
                    ...prevState,
                    data: null
                }));
                setPartyUsersPickerList(null);
                setIsInvalidUserSelector(false);
                inputParam_SetterUpdateUserCount && inputParam_SetterUpdateUserCount(inputParam_SectionPartyId, sectionPartyUserList.data.length);
                inputParam_SetterFireGetBookUsers && inputParam_SetterFireGetBookUsers(true);
            }).catch(() => {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
            //Enviar a guardar los usuarios seleccionados en la lista de distribución de la parte en el libro.
        }
        else {
            setShowMessage(true)
            setMessageType("warning");
            setMessage(t('data-lang-msg-nodatatoadd'))
        }
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
        setSelectedPickerUsers(null);
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onChangePickerUserParty = (currentNode, selectedNodes) => {
        setSelectedPickerUsers(prevState => ({
            ...prevState,
            data: selectedNodes
        }));

        partyUsersPickerList.forEach(x => {
            x.checked = x.username === currentNode.username ? currentNode.checked : x.checked;
        })

        setIsInvalidUserSelector(false);
        setShowMessage(false);
    };

    const onAddUserToUserList = () => {
        const isValidUserSelector = selectedPickerUsers.data !== null && selectedPickerUsers.data.length > 0;

        if (isValidUserSelector) {
            const resultUserList = sectionPartyUserList.data !== null ? joinWithoutDupes(selectedPickerUsers.data, sectionPartyUserList.data, "username") : selectedPickerUsers.data

            setSectionPartyUserList(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: resultUserList
            }));
            
            setSelectedPickerUsers(prevState => ({
                ...prevState,
                data: null
            }));

            setPartyUsersPickerList(null);
            setIsInvalidUserSelector(false);
            setShowMessage(false);
        }
        else {
            setIsInvalidUserSelector(!isValidUserSelector);
            setShowMessage(true);
            setMessage(t('data-lang-msg-requireddatanotset'))
            setMessageType("warning");
        }
    };

    const onDeleteUserFromListClick = (item, setItemToDelete) => {

        //Si el elemento no es volatil (Que esta en la base de datos), se borra con servicio.
        //Si el elemento es volatil (Que esta solo en la lista web, dado que recien ahora se queria agregar),
        //solo se borra del listado, esto ultimo ocurre en #CUSTOMDELETE# (Buscar en este archivo, hay un comentario en otro que indica por que se hizo así).
        if (item.label === undefined) {
            deleteSectionPartyUserById(item.id).then((response) => {
                //No se elimina desde listado ya que esto lo hace #CUSTOMDELETE# (Buscar en este archivo).
                //De lo contrario tendría dos cosas iguales.
            }).catch(() => {

            });
        }

        setItemToDelete(item);
    };

    const onRenderFooterContent = () => {
        return <div>
            {
                inputParam_EditMode && inputParam_UserHasConfigRoleAction && sectionPartyUserList.data && sectionPartyUserList.data.length > 0 &&
                <PrimaryButton onClick={onSaveSectionPartyUserList} styles={_global_buttonStyles}>{t('data-lang-btn-save')}</PrimaryButton>
            }
            <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
        </div>
    }

    //#CUSTOMDELETE#
    if (itemToDelete !== null) {
        let newUserList = [];

        sectionPartyUserList.data.forEach(obj => {
            if (obj.username !== itemToDelete.username) {
                newUserList.push(obj)
            }
        })

        setSectionPartyUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: newUserList
        }));

        inputParam_SetterUpdateUserCount && inputParam_SetterUpdateUserCount(inputParam_SectionPartyId, newUserList.length);
        inputParam_SetterFireGetBookUsers && inputParam_SetterFireGetBookUsers(true);
        
        setItemToDelete(null);
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-lbl-selectuserspartysection') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                {
                    inputParam_EditMode && inputParam_UserHasConfigRoleAction &&
                    <>
                        <Row className="pt-3">
                            <Col>
                                <Picker
                                    data={ partyUsersPickerList !== null ? partyUsersPickerList : [] }
                                    mode="multiSelect"
                                    className="dropdown-checkbox remove-position"
                                    isInValid={ isInvalidUserSelector }
                                    texts={{ placeholder: t('data-lang-lbl-chooses') }}
                                    onChange={ onChangePickerUserParty }
                                    labelText={ t('data-lang-lbl-partys') }
                                    refresh={true}
                                />
                                <CValidator isInValid={ isInvalidUserSelector } />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <PrimaryButton onClick={ onAddUserToUserList } styles={ buttonAddStyles }>{ t('data-lang-btn-add') }</PrimaryButton>
                            </Col>
                        </Row>
                    </>
                }
                <Row className="pt-3">
                    <Col>
                    {
                        sectionPartyUserList.data !== null &&
                        <List
                            listLocalStoragePageSizeVariableName="sectionPartysUsers"
                            className="no-compact-list big-header"
                            manipulateLocalData={ true }
                            setData={setSectionPartyUserList}
                            data={sectionPartyUserList}
                            columns={[
                                {
                                    key: 'username',
                                    name: t('data-lang-lbl-username'),
                                    fieldName: 'username',
                                    minWidth: 400,
                                    maxWidth: 400,
                                    onRender:(item) => {
                                        return <div>{ item.fullname }</div>
                                    }
                                },
                                {  
                                    key: 'id',
                                    name: t('data-lang-lbl-actions'),
                                    fieldName: 'username',
                                    //minWidth: "10%",
                                    //maxWidth: "10%",
                                    onRender:(item, row) => {
                                        return  inputParam_EditMode && inputParam_UserHasConfigRoleAction && <div>
                                                    <OverflowSet
                                                        className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                        role="menubar"
                                                        items={[
                                                            {
                                                                key: 'item1',
                                                                icon: 'Delete',
                                                                name: t('data-lang-btn-delete'),
                                                                title: t('data-lang-btn-delete'),
                                                                onClick: () => onDeleteUserFromListClick(item, setItemToDelete),
                                                            }
                                                        ]}
                                                        onRenderOverflowButton={__onRenderOverflowButton}
                                                        onRenderItem={__onRenderOverflowItem}
                                                    />
                                                </div>
                                    }
                                }
                            ]}
                        />
                    }
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium-pagination">
                    {
                        sectionPartyUserList.data !== null &&
                        <ListPagination
                            listLocalStoragePageSizeVariableName="sectionPartysUsers"
                            data={ sectionPartyUserList }
                            setData={ setSectionPartyUserList } />
                    }
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium-message">
                        <Message message={ message } display={ showMessage === null? false : showMessage } messageType={messageType} setterShowMessage={ setShowMessage } />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelUsers;